import { Loading } from '@components/atomic/atoms';
import { getDpa } from '@lib/api_ts/dpaApi';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import NotFoundPage from './404';

interface DpaPreviewProps {}

const DpaPreview: React.FC<DpaPreviewProps> = () => {
	const { data, isPending, isError } = useQuery({
		queryKey: ['dpa-preview'],
		queryFn: getDpa,
	});

	if (isPending) return <Loading />;
	if (isError) return <NotFoundPage />;

	return <iframe title="dpa-preview" src={URL.createObjectURL(data)} width="100%" height="100%" />;
};

export default DpaPreview;
